import styled from 'styled-components';

import { media } from 'helpers/breakpoints';
import {
  InfoTitle,
  type InfoTitleProps,
} from '../../../components/Toolkit/InfoTitle/InfoTitle';
import { DetailList } from '../../../components/Toolkit/DetailList/DetailList';
import type { InfoListItemProps } from '../../../components/Toolkit/InfoListItem/InfoListItem';
import { Link } from '../../../components/Toolkit/Button/Link';

export interface DetailPanelProps extends InfoTitleProps {
  detailListItems: InfoListItemProps[];
  link?: {
    url?: string;
    text?: string;
    external?: boolean;
  };
  illustrationUrl: string;
  className?: string;
}

const SLink = styled(Link)`
  margin-left: ${({ theme }) => theme.spacing.L56};

  ${media.medium} {
    position: absolute;
    top: 0;
    right: 0;
    margin-left: 0;
  }
`;

const Container = styled.div`
  ${media.medium} {
    position: relative;
  }
`;

const SDetailList = styled(DetailList)`
  padding: ${({ theme }) =>
    `${theme.spacing.M16} ${theme.spacing.M16} 0 ${theme.spacing.M16}`};
`;

function DetailPanel({
  detailListItems,
  link,
  title,
  listItems,
  illustrationUrl,
  className,
}: DetailPanelProps) {
  return (
    <Container className={className}>
      <InfoTitle
        title={title}
        listItems={listItems}
        illustration={illustrationUrl}
      />
      {link && (
        <SLink
          ofType="SECONDARY"
          href={link?.url}
          target={link?.external ? '_blank' : '_self'}
          data-testid="detail-panel-link"
          rel={link?.external ? 'noopener' : undefined}
          underline
        >
          {link?.text}
        </SLink>
      )}
      <SDetailList list={detailListItems} />
    </Container>
  );
}

export { DetailPanel };
